import { MyLink } from '@/src/components/AppComponents/MyLink/MyLInk';
import { WEBSITE_LINK_TO_MAIN_PAGE, WEBSITE_NAME } from '@/src/utils/constants';
import { DISCORD, INSTAGRAM, MEDIUM, TWITTER, WEBSITE } from '@/src/utils/images';
import { ROUTES } from '@/src/utils/routes';
import { IconBrandGithub } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import styles from './Footer.module.scss';
import NextLink from 'next/link';

export default function Footer() {
    //--------------------------------------
    const [isRefreshing, setIsRefreshing] = useState(true);
    useEffect(() => {
        setIsRefreshing(false);
    }, []);
    //-------------------------------------
    const github = process.env.NEXT_PUBLIC_LINK_GITHUB;
    const discord = process.env.NEXT_PUBLIC_LINK_DISCORD;
    const twitter = process.env.NEXT_PUBLIC_LINK_TWITTER;
    const instagram = process.env.NEXT_PUBLIC_LINK_INSTAGRAM;
    const medium = process.env.NEXT_PUBLIC_LINK_MEDIUM;
    return (
        <div className={styles.footer}>
            {/* Social Media Icons Row */}
            <div className={styles.socials}>
                <a href={WEBSITE_LINK_TO_MAIN_PAGE} target="_blank" rel="noopener noreferrer">
                    <svg className={styles.icon}>
                        <use xlinkHref={WEBSITE} />
                    </svg>
                </a>
                <a href={github} target="_blank" rel="noopener noreferrer">
                    <IconBrandGithub stroke={2} className={styles.iconWWithStroke} />
                </a>
                <a href={twitter} target="_blank" rel="noopener noreferrer">
                    <svg className={styles.icon}>
                        <use xlinkHref={TWITTER} />
                    </svg>
                </a>
                <a href={discord} target="_blank" rel="noopener noreferrer">
                    <svg className={styles.icon}>
                        <use xlinkHref={DISCORD} />
                    </svg>
                </a>
                <a href={medium} target="_blank" rel="noopener noreferrer">
                    <svg className={styles.icon}>
                        <use xlinkHref={MEDIUM} />
                    </svg>
                </a>
                <a href={instagram} target="_blank" rel="noopener noreferrer">
                    <svg className={styles.icon}>
                        <use xlinkHref={INSTAGRAM} />
                    </svg>
                </a>
            </div>

            {/* Legal Links Row */}
            <div className={styles.legalLinks}>
                <MyLink href={ROUTES.DISCLAIMER} >
                    <div className={styles.disclaimer_link}>Disclaimer</div>
                </MyLink>
                <div className={styles.copyright}>·</div>
                <NextLink href={WEBSITE_LINK_TO_MAIN_PAGE} legacyBehavior>
                    <a className={styles.copyright} target="_blank" rel="noopener noreferrer">
                        © {WEBSITE_NAME}
                    </a>
                </NextLink>
            </div>
        </div>
    );
}
